// extracted by mini-css-extract-plugin
module.exports = {"root":"appbar_root__wcT_J"};